export default function LogoAdoraTeam({ size = 40, glow = false }) {
    return (
        <img
            src="/logo.png"
            alt="AdoraTeam"
            style={{
                width: size,
                height: "auto",
                display: "block",
                margin: "0 auto",
                background: "transparent",
                filter: glow
                    ? "drop-shadow(0 0 12px #F9A826) drop-shadow(0 0 30px #F9A82677)"
                    : "none"
            }}
        />
    );
}